/** 前台會員 localStorage key */
export const MEMBER_STORAGE_KEYS = {
  TOKEN: 'formosa_member_token',
  USER: 'formosa_member_user',
  PERMISSIONS: 'formosa_member_permissions',
};

/** 後台管理員 localStorage key */
export const ADMIN_STORAGE_KEYS = {
  TOKEN: 'formosa_admin_token',
  USER: 'formosa_admin_user',
  PERMISSIONS: 'formosa_admin_permissions',
  ROLE: 'formosa_admin_role',
};
